import Snackbar from "@material-ui/core/Snackbar";
import AddIcon from "@mui/icons-material/Add";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { Fab } from "@mui/material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import { useTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { makeStyles } from "@mui/styles";
import { visuallyHidden } from "@mui/utils";
import axios from "axios";
import moment from "moment";
import PropTypes from "prop-types";
import React, { SyntheticEvent, useEffect } from "react";
import { useQuery } from "react-query";
import AddOutage from "../Drawers/AddOutage";
import MySnackbarContentWrapper from "../MySnackbarContentWrapper";
import AvailablityApi from "../services/API/Availablity.Api";
import { BASE_URL } from "../services/client/rest";

function descendingComparator(a: any, b: any, orderBy: any) {
  var x = a[orderBy];
  var y = b[orderBy];
  if (a[orderBy] == null) {
    if (orderBy == "DateLive") {
      x = "01/01/2000";
    }
    if (orderBy == "DateBuilt") {
      x = "01/01/2000";
    }
  }
  if (b[orderBy] == null) {
    if (orderBy == "DateLive") {
      y = "01/01/2000";
    }
    if (orderBy == "DateBuilt") {
      x = "01/01/2000";
    }
  }
  if (y < x) {
    return -1;
  }
  if (y > x) {
    return 1;
  }
  return 0;
}

function getComparator(order: any, orderBy: any) {
  return order === "desc"
    ? (a: any, b: any) => descendingComparator(a, b, orderBy)
    : (a: any, b: any) => -descendingComparator(a, b, orderBy);
}

function stableSort(array: any, comparator: any) {
  const stabilizedThis = array.map((el: any, index: any) => [el, index]);
  stabilizedThis.sort((a: any, b: any) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el: any) => el[0]);
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
  },
  alert1: { backgroundColor: "#E74C3C", color: "white" },
  hideCell: {
    display: "none !important",
  },
}));

export default function Availability({
  search,
  queryType,
}: {
  search: string;
  queryType: number;
}) {
  const [order, setOrder] = React.useState<string>("asc");
  const [orderBy, setOrderBy] = React.useState("Name");
  const [selected, setSelected] = React.useState([] as any);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [data, SetData] = React.useState([] as any);
  const [uptime, SetUptime] = React.useState([] as any);
  const [aspenUptime, SetAspenUptime] = React.useState([] as any);
  const [totalInstances, SetTotalInstances] = React.useState(0 as number);
  const [idealActiveUsers, setIdealActiveUsers] = React.useState(0 as number);
  const [idealInstances, SetIdealInstances] = React.useState(0 as number);
  const [currentRow, SetCurrentRow] = React.useState([] as any);
  const [showOutage, SetShowOutage] = React.useState(false);
  const [openSnackBar, setOpen] = React.useState(false);

  var bearer = "Bearer " + localStorage.getItem("token");

  const handleClose = (event?: SyntheticEvent, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const headers = {
    Authorization: bearer,
  };

  function CloseOutageDrawer(value: number = 0) {
    SetShowOutage(value == 0 ? false : true);
  }

  const useStyles1 = makeStyles((theme: any) => ({
    root: {
      flexShrink: 0,
    },
  }));

  function AddNew() {
    SetCurrentRow([]);
    SetShowOutage(true);
  }

  function SaveChanges(rowOutage: any) {
    if (
      rowOutage.customerReportedIncident == null ||
      rowOutage.customerReportedIncident == undefined
    ) {
      rowOutage.customerReportedIncident = false;
    }

    const request = {
      Id: rowOutage.id,
      OutageDate: rowOutage.outageDate,
      Environment: rowOutage.environment,
      OutageStartTime: rowOutage.outageStartTime,
      OutageEndTime: rowOutage.outageEndTime,
      Summary: rowOutage.summary,
      RootCause: rowOutage.rootCause,
      Resolution: rowOutage.resolution,
      DealersAffected: rowOutage.dealersAffected,
      ProductType: rowOutage.productType,
      EscalateTime: rowOutage.escalateTime,
      AckEscalateTime: rowOutage.ackEscalateTime,
      ResolveTime: rowOutage.resolveTime,
      CustomerReportedIncident: rowOutage.customerReportedIncident,
    };

    SetShowOutage(false);
    //
    axios
      .post(BASE_URL + "Availability/AddEditOutage", request, {
        headers,
      })
      .then((response) => {
        setOpen(true);
        GetOutages();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const handleRowClick = (currentRow: any) => {
    SetCurrentRow(currentRow);
    SetShowOutage(true);
  };

  const headCells = [
    {
      id: "id",
      numeric: true,
      disablePadding: false,
      label: "Incident ID",
    },
    {
      id: "productType",
      numeric: false,
      disablePadding: false,
      label: "ProductType",
    },
    {
      id: "outageDate",
      numeric: false,
      disablePadding: false,
      label: "OutageDate",
    },
    {
      id: "environment",
      numeric: false,
      disablePadding: false,
      label: "Environment",
    },
    {
      id: "outageStartTime",
      numeric: false,
      disablePadding: false,
      label: "OutageStartTime",
    },
    {
      id: "outageEndTime",
      numeric: false,
      disablePadding: false,
      label: "OutageEndTime",
    },
    {
      id: "dealersAffected",
      numeric: true,
      disablePadding: false,
      label: "DealersAffected",
    },
    { id: "summary", numeric: false, disablePadding: false, label: "Summary" },
  ];

  function EnhancedTableHead(props: any) {
    const {
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      onRequestSort,
    } = props;
    const createSortHandler = (property: any) => (event: any) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {headCells.map((headCell) => (
            <TableCell
              style={{ backgroundColor: "#F2F3F4" }}
              key={headCell.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  function TablePaginationActions(props: any) {
    const classes = useStyles1();
    const theme: any = useTheme();
    const { count, page, rowsPerPage, onChangePage } = props;

    const handleFirstPageButtonClick = (event: any) => {
      setPage(0);
    };

    const handleBackButtonClick = (event: any) => {
      setPage(page - 1);
    };

    const handleNextButtonClick = (event: any) => {
      setPage(page + 1);
    };

    const handleLastPageButtonClick = (event: any) => {
      setPage(Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <div className={classes.root}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRightIcon />
          ) : (
            <KeyboardArrowLeftIcon />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeftIcon />
          ) : (
            <KeyboardArrowRightIcon />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    );
  }

  TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
  };

  //----------------- useQuery for Fetching User-Cost -----------------//
  const { data: userCost, isFetching } = useQuery(
    ["GetUserCost", queryType],
    () => AvailablityApi.getUserCost(),
    {
      initialData: [],
      keepPreviousData: true,
    }
  );

  //----------------- Fetch Infinity Uptime -----------------//
  const { data: infinityUptime } = useQuery(
    ["getInfinityUptime", queryType],
    () => AvailablityApi.getInfinityUptime(),
    {
      initialData: [],
      keepPreviousData: true,
    }
  );

  useEffect(() => {
    GetOutages();
    GetUptime();
    GetAspenUptime();
  }, [queryType]);

  function GetOutages() {
    let url = BASE_URL + "Availability";
    fetch(url, {
      method: "get",
      headers: new Headers({
        Authorization: bearer,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => SetData(data.data))
      .catch((error) => {});
  }

  function GetUptime() {
    let url = BASE_URL + "Availability/Uptime";

    fetch(url, {
      method: "get",
      headers: new Headers({
        Authorization: bearer,
      }),
    })
      .then((response) => response.json())
      .then(
        (data) => (
          SetUptime(data.uptimes),
          setIdealActiveUsers(data.currentActiveUsers),
          SetTotalInstances(data.totalInstances),
          SetIdealInstances(data.idealInstances)
        )
      )
      .catch
      //error => alert('Error: ' + error)
      ();
  }

  function GetAspenUptime() {
    let url = BASE_URL + "Availability/AspenUptime";

    fetch(url, {
      method: "get",
      headers: new Headers({
        Authorization: bearer,
      }),
    })
      .then((response) => response.json())
      .then((data) => SetAspenUptime(data.uptimes))
      .catch();
  }

  const handleRequestSort = (event: any, property: any) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event: any) => {};

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - GetData().length) : 0;

  function GetData() {
    return data.filter(filterRow);
  }
  function filterRow(element: any, index: any, array: any) {
    if (data.length > 0) {
      var obj1 = data[0];
      var keys = Object.keys(obj1);
      let i = 0;
      for (i = 0; i < keys.length; i++) {
        let cellValue = String(element[keys[i]]);
        if (cellValue.toLowerCase().includes(search.toLowerCase())) {
          return true;
        }
      }
    }
    return false;
  }

  function ConvetToLocalTime(value: any) {
    return new Date(value.toString().replace("T", " ") + " UTC");
  }

  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <Box sx={{ width: "auto", display: "table" }}>
        {/********** Ideal Statistics **********/}
        <Box style={{ display: "table", margin: "30px 0px 30px 0px" }}>
          <fieldset
            style={{
              fontSize: "18pt",
              fontWeight: "bold",
              border: "1px solid silver",
            }}
          >
            <legend>&nbsp;Ideal Statistics&nbsp;</legend>

            <Table
              sx={{ minWidth: 650 }}
              aria-label="simple table"
              className={"myTable"}
            >
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontSize: "15pt" }}>Days</TableCell>
                  <TableCell style={{ fontSize: "15pt" }} align="right">
                    Uptime %
                  </TableCell>
                </TableRow>
              </TableHead>
              {uptime.map((row: any, index: any) => {
                return (
                  <TableRow
                    hover
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    role="checkbox"
                  >
                    <TableCell style={{ fontSize: "15pt" }}>
                      {row.days}
                    </TableCell>
                    <TableCell style={{ fontSize: "15pt" }}>
                      {row.uptimeVal.substring(0, 6)}
                    </TableCell>
                  </TableRow>
                );
              })}
            </Table>

            {/* ---------------------------------------------------------- */}

            <Table
              sx={{ minWidth: 650 }}
              aria-label="simple table"
              className={"myTable"}
            >
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontWeight: "bold" }}>
                    Ideal Instance
                  </TableCell>

                  <TableCell style={{ fontWeight: "bold" }}>
                    Current Active Users
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <TableRow
                  hover
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  role="checkbox"
                >
                  <TableCell style={{ fontWeight: "bold" }}>
                    {idealInstances}
                  </TableCell>

                  <TableCell style={{ fontWeight: "bold" }}>
                    {idealActiveUsers}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </fieldset>
        </Box>

        {/********** Infinity Statistics **********/}
        <Box style={{ display: "table", marginBottom: "30px" }}>
          <fieldset
            style={{
              fontSize: "18pt",
              fontWeight: "bold",
              border: "1px solid silver",
            }}
          >
            <legend>&nbsp;Infinity Statistics&nbsp;</legend>

            {/* ---------------------------------------------------------- */}

            <Table
              sx={{ minWidth: 650 }}
              aria-label="simple table"
              className={"myTable"}
            >
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontSize: "15pt" }}>Days</TableCell>
                  <TableCell style={{ fontSize: "15pt" }}>Uptime %</TableCell>
                </TableRow>
              </TableHead>
              {infinityUptime?.uptimes?.map((row: any, index: any) => {
                return (
                  <TableRow
                    hover
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    role="checkbox"
                  >
                    <TableCell style={{ fontSize: "15pt" }}>
                      {row.days}
                    </TableCell>
                    <TableCell style={{ fontSize: "15pt" }}>
                      {row.uptimeVal.substring(0, 6)}
                    </TableCell>
                  </TableRow>
                );
              })}
            </Table>

            {/* ---------------------------------------------------------- */}

            <Table
              sx={{ minWidth: 650 }}
              aria-label="simple table"
              className={"myTable"}
            >
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontWeight: "bold" }}>
                    Infinity Instance
                  </TableCell>

                  <TableCell style={{ fontWeight: "bold" }}>
                    Current Active Users
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <TableRow
                  hover
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  role="checkbox"
                >
                  <TableCell style={{ fontWeight: "bold" }}>
                    {infinityUptime?.infinityInstances}
                  </TableCell>

                  <TableCell style={{ fontWeight: "bold" }}>
                    {infinityUptime?.currentActiveUsers}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </fieldset>
        </Box>

        {/********** Totals Grid **********/}
        <Box style={{ display: "table", marginBottom: "30px" }}>
          <fieldset
            style={{
              fontSize: "18pt",
              fontWeight: "bold",
              border: "1px solid silver",
            }}
          >
            <legend>&nbsp;Ideal & Infinity Statistics&nbsp;</legend>

            <Table
              sx={{ minWidth: 650 }}
              aria-label="simple table"
              className={"myTable"}
            >
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontSize: "15pt" }}>
                    Total Instance
                  </TableCell>
                  <TableCell style={{ fontSize: "15pt" }}>
                    Total Active Users
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableRow
                hover
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                role="checkbox"
              >
                <TableCell style={{ fontSize: "15pt" }}>
                  {infinityUptime?.totalInstances}
                </TableCell>
                <TableCell style={{ fontSize: "15pt" }}>
                  {idealActiveUsers + infinityUptime?.currentActiveUsers}
                </TableCell>
              </TableRow>
            </Table>
          </fieldset>
        </Box>

        {/********** Aspen Statistics **********/}
        <Box style={{ display: "table", marginBottom: "30px" }}>
          <fieldset
            style={{
              fontSize: "18pt",
              fontWeight: "bold",
              border: "1px solid silver",
            }}
          >
            <legend>&nbsp;Aspen Statistics&nbsp;</legend>

            <Table
              sx={{ minWidth: 650 }}
              aria-label="simple table"
              className={"myTable"}
            >
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontSize: "15pt" }}>Days</TableCell>
                  <TableCell style={{ fontSize: "15pt" }} align="right">
                    Uptime %
                  </TableCell>
                </TableRow>
              </TableHead>
              {aspenUptime.map((row: any, index: any) => {
                return (
                  <TableRow
                    hover
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    role="checkbox"
                  >
                    <TableCell style={{ fontSize: "15pt" }}>
                      {row.days}
                    </TableCell>
                    <TableCell style={{ fontSize: "15pt" }}>
                      {row.uptimeVal.substring(0, 6)}
                    </TableCell>
                  </TableRow>
                );
              })}
            </Table>
          </fieldset>
        </Box>

        {/* ---------------------- User-Cost Table Start ----------------------- */}
        <Box style={{ display: "table", marginBottom: "30px" }}>
          <fieldset
            style={{
              fontSize: "18pt",
              fontWeight: "bold",
              border: "1px solid silver",
            }}
          >
            <legend>&nbsp;User Cost&nbsp;</legend>

            <Table
              sx={{ minWidth: 1080 }}
              aria-label="simple table"
              className={"myTable"}
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>Last Update</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>DMS Type</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    Licensed Users
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>Azure Cost</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>
                    Cost Per User
                  </TableCell>
                </TableRow>
              </TableHead>

              {userCost.map((row: any, index: any) => {
                return (
                  <TableRow
                    hover
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>
                      {moment(row.lastUpdate).format("DD/MM/YYYY")}
                    </TableCell>
                    <TableCell>
                      {row.dmsType == 0
                        ? "Ideal"
                        : row.dmsType == 1
                        ? "Infinity"
                        : row.dmsType == 9
                        ? "Aspen"
                        : "null"}
                    </TableCell>
                    <TableCell>{row.licensedUsers}</TableCell>
                    <TableCell>{row.azureCost}</TableCell>
                    <TableCell>{row.costPerUser}</TableCell>
                  </TableRow>
                );
              })}
            </Table>
          </fieldset>
        </Box>
        {/* ---------------------- User-Cost Table End ----------------------- */}

        <Paper
          sx={{
            width: "auto",
            mb: 2,
            marginTop: "20px",
            margin: "10px 10px",
            border: "1px solid #E5E7E9",
          }}
        >
          <TableContainer>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size={dense ? "small" : "medium"}
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={GetData().length}
              />
              <TableBody>
                {stableSort(GetData(), getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: any, index: any) => {
                    let outageStartTime = "";
                    if (row.outageStartTime != null)
                      outageStartTime = ConvetToLocalTime(
                        row.outageStartTime
                      ).toLocaleTimeString("en-US", {
                        hour: "numeric",
                        minute: "numeric",
                        hour12: true,
                      });

                    let outageEndTime = "";
                    if (row.outageEndTime != null)
                      outageEndTime = ConvetToLocalTime(
                        row.outageEndTime
                      ).toLocaleTimeString("en-US", {
                        hour: "numeric",
                        minute: "numeric",
                        hour12: true,
                      });

                    let outageDate = "";
                    if (row.outageDate != null)
                      outageDate = new Date(
                        row.outageDate
                      ).toLocaleDateString();

                    const isItemSelected =
                      row.id == currentRow.id ? true : false;

                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        onClick={(event) => handleRowClick(row)}
                        key={row.id}
                        selected={isItemSelected}
                      >
                        <TableCell align="center">{row.id}</TableCell>
                        <TableCell>{row.productType}</TableCell>
                        <TableCell>{outageDate}</TableCell>
                        <TableCell>{row.environment}</TableCell>
                        <TableCell>{outageStartTime}</TableCell>
                        <TableCell>{outageEndTime}</TableCell>
                        <TableCell align="right">
                          {row.dealersAffected}
                        </TableCell>
                        <TableCell>{row.summary}</TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: (dense ? 33 : 53) * emptyRows,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 20, 25, 50, 100]}
            component="div"
            count={GetData().length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
        </Paper>

        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          open={openSnackBar}
          autoHideDuration={5000}
          onClose={handleClose}
        >
          <MySnackbarContentWrapper
            onClose={handleClose}
            variant="success"
            message="Outage saved Sucessfully."
          />
        </Snackbar>

        <AddOutage
          open={showOutage}
          rowOutage={currentRow}
          SaveChanges={SaveChanges}
          onClose={CloseOutageDrawer}
        />
        <div style={{ position: "fixed", bottom: "10px", left: "5px" }}>
          <table>
            <tr>
              <td>
                <Fab
                  variant="extended"
                  size="medium"
                  color="primary"
                  onClick={() => AddNew()}
                  title="Add New"
                >
                  {<AddIcon></AddIcon>}Add New &nbsp;
                </Fab>
              </td>
            </tr>
          </table>
        </div>
      </Box>
    </Box>
  );
}
